import React, { Component } from 'react'
import Link from '../utils/Link'
import { type BaseBoxProps } from './Types'

export default class Box extends Component<BaseBoxProps> {
  render () {
    const {
      className,
      image,
      link,
      title
    } = this.props

    return (
      <Link href={link} className={className}>
        <div className='image-column'>
          { image }
        </div>
        <div className='title-column'>
          { title }
        </div>
      </Link>
    )
  }
}
